import {Account} from './account.model';

export class Skill {
  id: string;
  active: boolean;
  createdBy: string;
  name: string;
  constructor(json: any) {
    this.id = json.id || json._id;
    this.active = json.active;
    this.createdBy = json.createdBy;
    this.name = json.name;
  }
}

export enum SKILL_TYPE {
  HARD_SKILL = 'HARD_SKILL',
  SOFT_SKILL = 'SOFT_SKILL',
}

export class UserSkill {
  accountId: Account;
  active: boolean;
  credCount: number;
  id: string;
  ratingInPercentage: number;
  reccoCount: number;
  skill: Skill;
  type: SKILL_TYPE;
  constructor(json: any) {
    this.accountId = json.accountId && new Account(json.accountId);
    this.active = json.active;
    this.credCount = json.credCount;
    this.id = json.id || json._id;
    this.ratingInPercentage = json.ratingInPercentage;
    this.reccoCount = json.reccoCount;
    this.skill = json.skill && new Skill(json.skill);
    this.type = SKILL_TYPE[json.type as keyof typeof SKILL_TYPE];
  }
}
